import axios from 'axios';

// Change this to your Vercel backend URL
const BASE_URL = 'https://telgramagentbackend.vercel.app/'; // Replace with your actual Vercel URL

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
